import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import wineComponent from "@/components/products/WineComponent.vue";
export default {
  name: "NewWineDialog",
  props: {
    shown: Boolean,
    loggedUserData: Object,
    producerId: Number,
    supplierPrice: Object,
    wineForCloning: {
      type: Object,
      default: function _default() {
        return {
          wineIdForCloning: null,
          wine: {}
        };
      }
    }
  },
  created: function created() {
    this.$router.replace({
      query: {
        edit: true
      }
    }).catch(function (e) {});
    this.isWineComponentVisible = true;
  },
  data: function data() {
    return {
      id_wine: "",
      searchCriterias: {},
      returnRoute: "",
      routeParam: {},
      isWineComponentVisible: true
    };
  },
  methods: {
    close: function close() {
      this.isWineComponentVisible = false;
      this.$emit("close");
    },
    saved: function saved(wineId) {
      var _this$supplierPrice;
      if ((_this$supplierPrice = this.supplierPrice) !== null && _this$supplierPrice !== void 0 && _this$supplierPrice.wineSupplierPriceId) {
        this.$emit("savedForSupplier", {
          wineId: wineId,
          wineSupplierPriceId: this.supplierPrice.wineSupplierPriceId
        });
      } else {
        this.$emit("saved", wineId);
      }
    }
  },
  components: {
    wine: wineComponent
  }
};